import api from "./api";
import {
  ICategoriaCreate,
  ICategoriaUpdate,
  ICategoriaManageResponse,
  ICategoriaProduto,
} from "interfaces/loja";
import { ENDPOINTS } from "./endPoints";

/**
 * API: Listar as categorias da loja
 */
export async function getAllCategorias() {
  try {
    const { data, status } = await api.get<ICategoriaProduto[]>(
      "/loja/categorias/gerenciar"
    );
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * API: Arvore de categorias da loja
 */
export async function getCategoriasArvore(): Promise<{
  data: ICategoriaProduto[];
  status: number;
}> {
  const { url, method } = ENDPOINTS.LOJA.CATEGORIAS.LISTAR_ALL_TREE;
  try {
    const { data, status } = await api({
      url: url,
      method: method,
    });
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * API: Cadastrar uma categoria na loja
 */
export async function createCategoria(data: ICategoriaCreate) {
  try {
    const { data: responseData, status } =
      await api.post<ICategoriaManageResponse>("/loja/categorias", data);
    return { data: responseData, status } as {
      data: ICategoriaManageResponse;
      status: number;
    };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * API: Editar uma categoria na loja
 */
export async function updateCategoria(
  categoriaId: string,
  data: ICategoriaUpdate
) {
  try {
    const { data: responseData, status } =
      await api.put<ICategoriaManageResponse>(
        `/loja/categorias/${categoriaId}`,
        data
      );
    return { data: responseData, status } as {
      data: ICategoriaManageResponse;
      status: number;
    };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * API: Deletar uma categoria na loja
 */
export async function deleteCategoria(categoriaId: string) {
  try {
    const { data, status } = await api.delete(
      `/loja/categorias/${categoriaId}`
    );
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * Público: listar categorias
 */
export async function getPublicCategorias() {
  try {
    const { data, status } =
      await api.get<ICategoriaProduto[]>(`/loja/categorias`);
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

/**
 * Público: listar categorias em árvore
 */
export async function getPublicCategoriasTree() {
  try {
    const { data, status } = await api.get<ICategoriaProduto[]>(
      `/loja/categorias/tree`
    );
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}
